export default "__VITE_ASSET__CabAQBNt__"